import React from "react"
import { ITextProps } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {
  to: string
}

const Link = (props: Props) => {
  const className = `font-raleway-light text-xs sm:text-sm md:text-base underline ${mapStylesFromProps(
    props
  )}`
  return (
    <a
      href={props.to}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {props.children}
    </a>
  )
}

export default Link
